<script lang="ts">
  import styles from "../styles";

  const s = styles({});
</script>

<div class={s.dotFlashing} />
